import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { PartnerService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { PartnerCrudIndex } from './crud-index';
import { Router } from '@angular/router';
import { UserService } from '../../users/crud.service';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';
import { ContractGenerationService } from '../../contracts/services/contract-generation.service';
import { ContractsService } from '../../contracts/crud-service';

@Component({
  selector: 'app-product-category-select-index',
  templateUrl: './crud-index-multiselect.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [PartnerService],
})
export class PartnerIndexMultiSelectComponent extends PartnerCrudIndex {
  override title: string = 'SELECIONE O(S) PARCEIRO(S)';
  override COLUMNS_TO_SHOW_WEB = [
    'select',
    'image',
    'document',
    'name'
  ];
  preselectedIds: string[] = [];

  constructor(
    override dialog: MatDialog,
    override service: PartnerService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    public dialogRefSelect: MatDialogRef<PartnerIndexMultiSelectComponent>,
    override usersService: UserService,
    override router: Router,
    private fb: FormBuilder,
    protected override cdr: ChangeDetectorRef,
    protected override authService: AuthService,
    override permissionService: PermissionService,
    override contractsService: ContractsService,
    override contractGenerationService: ContractGenerationService,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      params: any;
      preselectedIds?: string[];
    }
  ) {
    super(dialog, service, toastService, mediaObserver, usersService,
      router, cdr, authService, permissionService, contractsService, contractGenerationService);
    this.dataSelect = data;
    this.params = { ...this.params, ...data.params };
    this.preselectedIds = Array.isArray(data.preselectedIds) ? data.preselectedIds : [];
  }

  ngOnInit(): void { }

  override loadList(): void {
    if (this.params.isConsultant) {
      let formGroupFilter = this.fb.group({
        isConsultant: [this.params.isConsultant]
      });

      this.submitAdvancedFilter(formGroupFilter);
    } else
      if (this.params.isPartner) {
        let formGroupFilter = this.fb.group({
          isPartner: [this.params.isPartner]
        });

        this.submitAdvancedFilter(formGroupFilter);
      } else
        if (this.params.isRepresentative) {
          let formGroupFilter = this.fb.group({
            isRepresentative: [this.params.isRepresentative]
          });

          this.submitAdvancedFilter(formGroupFilter);
        } else if (this.params.isSupplier) {
          let formGroupFilter = this.fb.group({
            isSupplier: [this.params.isSupplier]
          });

          this.submitAdvancedFilter(formGroupFilter);
        } else {
          super.loadList();
        }
  }

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(
        take(1)
      )
      .subscribe({
        next: (dataWithPagination: any) => {
          if (dataWithPagination && Array.isArray(dataWithPagination) && dataWithPagination.length >= 2) {
            const data = dataWithPagination[0] || [];
            this.length = dataWithPagination[1] || 0;

            this.dataSource = new MatTableDataSource<any>(
              data.map((item: any) => {
                item.name = item.name || item.companyName || '';
                return item;
              })
            );
          } else {
            this.dataSource = new MatTableDataSource<any>([]);
            this.length = 0;
          }
        },
        error: (error) => {
          console.error('ERROR', error);
          this.toastService.showError('Erro ao buscar parceiros. Tente novamente.');
          this.dataSource = new MatTableDataSource<any>([]);
          this.length = 0;
        }
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.isConsultant) params.isConsultant = filter.isConsultant;
    else delete params.isConsultant
    if (filter.isPartner) params.isPartner = filter.isPartner;
    else delete params.isPartner;
    if (filter.isRepresentative) params.isRepresentative = filter.isRepresentative;
    else delete params.isRepresentative;
    if (filter.isSupplier) params.isSupplier = filter.isSupplier;
    else delete params.isSupplier;

    return params;
  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(this.selection.selected);
  }
}
